<template>
	<!-- <div class="log" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10"> -->
	<div class="log">
		<div class="view-title">
			<translate>Log</translate>
		</div>
		<div class="log-search">
			<div class="search">
				<el-input class="search-input" :placeholder="attrText.command" v-model.trim="searchForm.keywords" @keyup.enter.native="onSearch(searchForm)"></el-input>
				<el-button class="search-btn" @click="onSearch(searchForm)">
					<translate>Search</translate>
				</el-button>
				<el-button type="text" @click.stop="onShowLogSearch()">
					<translate>Advanced Search</translate>
				</el-button>
				<div class="search-right">
					{{ getTranTest(log.totalNum) }}
					<a :href="importUrl" :disabled="!log.totalNum" target="_blank">
						<translate>Download Report</translate>
					</a>

					<span @click="videoReply" style="margin-left: 10px; color: #20a0ff; cursor: pointer">
						<translate>Video Reply</translate>
					</span>
					<!--<el-button class="btn-white" @click.stop="onShowLogReport()">-->
					<!--<translate>Generate Report</translate>-->
					<!--</el-button>-->
				</div>
			</div>
		</div>
		<!--表格-->
		<div class="table-wrapper">
			<!--搜索tag-->
			<div class="searchTag" v-if="log.tags.length">
				<el-tag v-for="(tag, index) in log.tags" :key="index" :closable="true" @close="onCloseTag(tag)">
					<span v-if="tag.val == 'transfer'">{{ `${tag.text}:文件传输` }}</span>
					<span v-else>{{ tag.key === 'unsafe_mode' ? tag.text : `${tag.text}:${tag.val}` }}</span>
				</el-tag>
			</div>
			<!-- <ul class="list-wrapper">
				<li v-for="(item, index) in log.list" :key="index">
					<el-col :span="1" class="avatar-wrapper">
						<img :src="item.avatar | resetURL" class="avatar" />
					</el-col>
					<el-col :span="13">
						<p class="accont-name">
							<span class="text-space" style="margin-left: 0">{{ item.account_name }}</span>
							<el-tooltip class="item" effect="dark" :content="attrText.commissionTeam" placement="top" v-if="currentCompany.id !== item.company_id && item.company_name">
								<span style="color: #ccc"> ({{ item.company_name }})</span>
							</el-tooltip>
							<el-tooltip class="item" effect="dark" :content="item.filename" placement="top" v-if="item.type === 'file_log'">
								<span class="text-space" v-if="item.op">{{ attrText[item.op] }} &nbsp;&nbsp;{{ item.filename }}&nbsp;&nbsp;{{ item.op === 'download' ? attrText.from : attrText.to }}</span>
							</el-tooltip>
							<span class="text-space">{{ item.resource_name }}</span>
							<el-tooltip class="item" effect="dark" :content="attrText.unsafeMode" placement="top" v-if="item.unsafe_mode === 1">
								<i class="fa fa-exclamation-circle warn"></i>
							</el-tooltip>
							<span class="project-name">{{ item.project_name }}</span>
						</p>
						<p v-if="item.type !== 'file_log'">
							<a v-if="item.way != 'rds' && item.way != 'mysql' && item.way != 'mssql' && item.way != 'postgresql' && item.play != 0" :href="item.playbackLink" target="_blank" class="play play-url">
								<translate>Play</translate>
							</a> -->
			<!-- <a class="down-url" v-if="item.way != 'rdp'" :href="item.downloadLink">
								<translate>Download</translate>
							</a> -->
			<!-- 	<a class="down-url" @click="downLog(item, false)">
								<translate>Download</translate>
							</a>
						</p>
					</el-col>
					<el-col :span="4">
						<div style="height: 40px; text-align: right">
							<p v-if="item.type !== 'file_log'">{{ item.client_ip_address }}</p>
							<p v-if="item.type !== 'file_log'">{{ item.way }}（连接方式）</p>
						</div>
					</el-col>
					<el-col :span="5" style="min-width: 150px; text-align: right">
						<p>{{ (item.start_date * 1000) | moment('YYYY-MM-DD HH:mm:ss') }}</p>
						<p v-show="item.type !== 'file_log'">{{ durTime(item.date, item.start_date) }}</p>
					</el-col>
				</li>
			</ul> -->
			<el-table :data="log.list" style="width: 100%" :height="tableMaxHeight" v-loading="loading">
				<el-table-column :label="attrText.operator">
					<template scope="scope">
						<div class="avatar-wrapper">
							<img :src="scope.row.avatar | resetURL" class="avatar" />
							<div>
								<p>{{ scope.row.account_name }}（{{ scope.row.client_ip_address }}）</p>
								<p>{{ scope.row.account }}</p>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column :label="attrText.workgroup" prop="project_name"> </el-table-column>
				<el-table-column :label="attrText.operationObj">
					<template scope="scope">
						<div class="flex items-start">
							<el-tooltip v-if="scope.row.os === 'linux'" class="item" effect="dark" content="Linux" placement="top">
								<img style="margin: 3px 5px 0 0" :src="`../../../static/images/linux.png`" alt="" />
							</el-tooltip>

							<el-tooltip v-if="scope.row.os === 'win32'" class="item" effect="dark" content="Windows" placement="top">
								<img style="margin: 3px 5px 0 0" :src="`../../../static/images/win32.png`" alt="" />
							</el-tooltip>

							<el-tooltip v-if="scope.row.os == 'postgresql'" class="item" effect="dark" content="PostgreSQL" placement="top">
								<img style="margin: 3px 5px 0 0" :src="`../../../static/images/postgresql.png`" width="16" height="16" alt="" />
							</el-tooltip>

							<el-tooltip v-if="scope.row.os == 'mysql'" class="item" effect="dark" content="MySQL" placement="top">
								<img style="margin: 3px 5px 0 0" :src="`../../../static/images/mysql.png`" alt="" width="16" height="16" />
							</el-tooltip>

							<el-tooltip v-if="scope.row.os == 'mssql'" class="item" effect="dark" content="SQL Server" placement="top">
								<img style="margin: 3px 5px 0 0" :src="`../../../static/images/mssql.png`" alt="" width="16" height="14" />
							</el-tooltip>

              <el-tooltip v-if="scope.row.os == 'oracle'" class="item" effect="dark" content="Oracle" placement="top">
                <img style="margin: 3px 5px 0 0" :src="`../../../static/images/oracle.png`" alt="" width="16" height="14" />
              </el-tooltip>

							<span>{{ scope.row.resource_name }}（{{ scope.row.resource_ip_address }}）</span>
						</div>
						<div>
							<span>{{ scope.row.login_username || '-' }}</span>
							<span style="margin: 0 5px">|</span>
							<span>{{ wayMap(scope.row.way) }}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column :label="attrText.operationTime">
					<template scope="scope">
						<p>开始：{{ (scope.row.start_date * 1000) | moment('YYYY-MM-DD HH:mm:ss') }}</p>
						<p>结束：{{ (scope.row.date * 1000) | moment('YYYY-MM-DD HH:mm:ss') }}</p>
						<p>时长：{{ durTime(scope.row.date, scope.row.start_date) }}</p>
					</template>
				</el-table-column>
				<el-table-column :label="attrText.action" width="150">
					<template scope="scope">
						<a v-if="scope.row.way != 'rds' && scope.row.way != 'mysql' && scope.row.way != 'mssql' && scope.row.way !== 'transfer' && scope.row.way != 'postgresql'&& scope.row.way != 'oracle' && scope.row.play != 0" :href="scope.row.playbackLink" target="_blank" class="play play-url">
							<translate>Play</translate>
						</a>
						<a v-if="scope.row.way != 'rdp'" class="view-url" @click="viewLog(scope.row, false)">
							<translate>View</translate>
						</a>
						<a class="down-url" @click="downLog(scope.row, false)">
							<translate>Download</translate>
						</a>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination" v-if="log.totalPage > 10">
				<el-pagination layout="total, prev, pager, next" :total="log.totalPage" :page-size="10" :current-page.sync="log.currentPage" @current-change="onChangePage"></el-pagination>
			</div>
			<!-- <div class="loading-next" v-if="loading" v-loading="loading" style="height: 100px; z-index: 5"></div> -->
		</div>
		<!-- <div class="no-more" v-if="(!loading && log.list.length === 0) || (log.totalNum === log.list.length && !loading) || (dataError && !loading)">
			<translate>No More Data</translate>
		</div> -->

		<component :is="currentRightPanel" :items="rightPanelData" @onClosePanel="onClosePanel" @callback="onSearch"></component>

		<!--是否解冻-->
		<el-dialog title="日志解冻" :visible.sync="freezeShow" class="dialog" top="20px" @close="closeDialog">
			<div class="dialog-content" v-loading="pollingLoading" element-loading-text="日志正在解冻中，请稍等...">
				<p class="text" v-if="pollingCode == 'OSSFileAvailable'">解冻完成，文件正在下载...</p>
				<p class="text" v-else>检测到您所选择的日志文件目前处于"冷冻"归档状态，如您需要继续"下载"，请点击"确认"发起解冻请求。日志文件"解冻"通常需要5-10分钟左右，请耐心等待。</p>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" :disabled="pollingLoading" link @click="freezeShow = false">取消</el-button>
				<el-button v-if="pollingLoading || pollingCode == 'OSSFileArchived'" type="primary" :disabled="pollingLoading" @click="handleFreezeConfirm">确认</el-button>
				<!-- <el-button v-if="pollingCode == 'OSSFileAvailable'" type="primary" :disabled="pollingLoading" @click="downLogFile(freezeShowRow)">下载</el-button> -->
			</div>
		</el-dialog>

		<!-- 日志查看弹窗 -->
		<el-dialog title="日志内容查看" :visible.sync="viewLogShow" width="90%" top="20px" @close="closeViewLogDialog">
			<div class="log-view-content" v-loading="viewLogLoading" element-loading-text="加载日志内容中...">
				<!-- 支持横向/纵向滚动 -->
				<pre>{{ logContent }}</pre>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" v-clipboard:copy="logContent" v-clipboard:success="copySuccess" v-clipboard:error="copyError"><translate>Copy</translate></el-button>
				<el-button type="" @click="viewLogShow = false"><translate>Close</translate></el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import STORE_CONST from '../../store/consts'
import LogSearch from './model/log-search'
import LogReport from './model/log-report'
import { baseUrl, Utils } from '../../config'
import moment from '../../../node_modules/moment/src/moment'
import Utility from '../../Utils'
export default {
	data() {
		return {
			loading: false,
			freezeShow: false,
			freezeShowRow: '',
			log: {
				baseUrl: baseUrl,
				tags: [],
				delTag: '',
				list: [],
				totalNum: 0,
				loadPage: 2,
				totalPage: 0,
				currentPage: 1,
			},
			searchForm: {
				keywords: '',
			},
			importUrl: baseUrl.apiUrl + '/search_tunnel' + '?' + 'export=true',
			scroll: false,
			busy: false,
			dataError: false,
			currentRightPanel: null,
			rightPanelData: null,
			pollingTimer: null,
			pollingLoading: false,
			pollingCode: '', //OSSFileArchived 冻结  /  OSSFileRestoring 解冻中  /  OSSFileAvailable 已解冻

			viewLogShow: false, // 查看日志弹窗显示状态
			viewLogLoading: false, // 日志加载中状态
			logContent: '', // 日志文本内容
			viewLogRow: '', // 查看日志的行数据
		}
	},
	computed: {
		attrText() {
			return this.getTransitionText()
		},
		languageCurrent() {
			return this.$language.current
		},
		currentCompany() {
			console.log('currentCompany', this.$store.getters.team.setting)
			return this.$store.getters.team.setting
		},
		tableMaxHeight() {
			return window.innerHeight - 300
		},
	},
	created() {
		this.onSearch({})
	},
	methods: {
		wayMap(way) {
			const way_map = {
				rdp: 'Windows（RDP）',
				terminal: 'Linux（SSH）',
				mysql: 'MySQL',
				mssql: 'MSSQL',
				postgresql: 'PostgreSQL',
				oracle: 'Oracle',
				transfer: this.attrText.fileTransfer,
			}

			return way_map[way]
		},
		durTime(data, startData) {
			let time = (data - startData) * 1000
			let h = parseInt(moment.duration(time).asHours())
			let m = moment.duration(time).minutes()
			let s = moment.duration(time).seconds()
			if (h < 10) {
				h = '0' + h
			}
			if (m < 10) {
				m = '0' + m
			}
			if (s < 10) {
				s = '0' + s
			}
			return h + ':' + m + ':' + s
		},
		href(link) {
			window.location.href = link
		},
		showDetail(id) {
			if (this.log.detailRow !== id) {
				this.log.detailRow = id
			} else {
				this.log.detailRow = ''
			}
			console.log(id)
		},
		getTranTest(clusters) {
			let translated = this.$ngettext('%{ n } record', '%{ n } records', clusters)
			let interpolated = this.$gettextInterpolate(translated, { n: clusters })
			return interpolated
		},

		// 获取翻译文本
		getTransitionText() {
			return {
				command: this.$gettext('Input history command'),
				tagCommand: this.$gettext('Command'),
				now: this.$gettext('Now'),
				hour: this.$gettext('hour'),
				minute: this.$gettext('minute'),
				second: this.$gettext('second'),
				unsafeMode: this.$gettext('Unsafe Mode'),
				commissionTeam: this.$gettext('Commission Team'),
				download: this.$gettext('Download'),
				upload: this.$gettext('Upload'),
				from: this.$gettext('From'),
				to: this.$gettext('To'),
				ip: this.$gettext('IP'),
				operator: this.$gettext('Operator'),
				workgroup: this.$gettext('Workgroup'),
				operationObj: this.$gettext('Operation Obj'),
				operationTime: this.$gettext('Operation Time'),
				action: this.$gettext('Action'),
				fileTransfer: this.$gettext('File Transfer'),
			}
		},
		copySuccess(e) {
			this.$notify({
				message: this.$gettext('Copy successfully!'),
				type: 'success',
			})
			e.clearSelection()
		},
		copyError(e) {
			this.$notify({
				message: this.$gettext('Copy Failed!'),
				type: 'failed',
			})
		},
		// 加载更多
		loadMore() {
			console.log('loadmore')
			this.busy = true
			this.scroll = true
			if (this.log.list.length > 0 && this.log.list.length < this.log.totalNum && !this.dataError) {
				this.getLogList(this.log.loadPage)
				this.log.loadPage++
			} else {
				this.busy = true
			}
		},

		// 分页
		onChangePage(page) {
			this.getLogList(page)
		},
		// 获取日志列表
		getLogList(page) {
			this.loading = true
			this.dataError = false
			this.importUrl = baseUrl.apiUrl + '/search_tunnel' + '?' + 'export=true'
			let params = {
				page_index: page || 1,
				page_size: 10,
			}
			this.log.tags.forEach((item) => {
				if (item.key === 'timeRange') {
					let time = item.val.split(' - ')
					params['time_from'] = moment(time[0]).format('x') / 1000
					if (time[1] === this.attrText.now) {
						let now = new Date()
						params['time_end'] = Math.ceil(now.getTime() / 1000)
					} else {
						params['time_end'] = moment(time[1]).format('x') / 1000 + +24 * 3600
					}
				} else {
					if (this.$route.query.resourceName) {
						params['resource_id'] = this.$route.query.resourceName.split(':')[0]
					} else {
						params[item.key] = item.val
					}
				}
				if (item.key === 'way') {
					if (item.val === 'Linux') {
						params['way'] = 'terminal'
					} else if (item.val === 'Windows') {
						params['way'] = 'rdp'
					} else if (item.val === 'MySQL') {
						params['way'] = 'mysql'
					} else if (item.val === 'SQL Server') {
						params['way'] = 'mssql'
					}
				}
			})
			this.$store.dispatch(STORE_CONST.LOG.ACTION, { params: params }).then(
				(res) => {
					console.log(res, 'res')

					Object.forEach(params, (key, val) => {
						if (val === 'page_size') {
							this.importUrl += '&' + val + '=' + Utils.config.maxPageSize
						} else {
							this.importUrl += '&' + val + '=' + key
						}
					})
					this.importUrl += '&' + 'lang=' + this.languageCurrent
					this.loading = false
					this.log.totalNum = res.total || 0
					this.log.totalPage = res.total

					let data = []
					if (res.data && res.data.length) {
						res.data.forEach((item, index) => {
							let _playbackLink = 'playlog.html'
							let _downloadLink = this.log.baseUrl.apiUrl + '/download_tunnel_log'
							_playbackLink += '#?link=' + this.log.baseUrl.apiUrl
							_playbackLink += '&way=' + item.way
							_playbackLink += '&code=' + item.code
							_playbackLink += '&resource_id=' + item.resource_id
							_playbackLink += '&account_name=' + item.account_name
							_playbackLink += '&avatar=' + item.avatar
							_playbackLink += '&account_id=' + item.account_id
							if (this.searchForm.keywords) {
								_playbackLink += '&keywords=' + this.searchForm.keywords
							}
							if (item.agent_version) {
								_playbackLink += '&version=' + Utility.Utils.getAgentVersion(item.agent_version)
							}
							_playbackLink += '&start_time=' + item.start_date
							_playbackLink += '&date=' + item.date
							_downloadLink += '?way=' + item.way
							_downloadLink += '&code=' + item.code
							_downloadLink += '&start_time=' + item.start_date
							if (item.connection_id) {
								_playbackLink += '&connection_id=' + item.connection_id
								_downloadLink += '&connection_id=' + item.connection_id
							}
							if (item.guacamole) {
								_playbackLink += '&guacamole=' + item.guacamole
								if (item.rdp_width && item.rdp_height) {
									_playbackLink += '&rdp_width=' + item.rdp_width
									_playbackLink += '&rdp_height=' + item.rdp_height
								}
							}
							_playbackLink += '&lang=' + this.languageCurrent
							_playbackLink += '&type=playlog'
							item.playbackLink = _playbackLink
							item.downloadLink = _downloadLink
							data.push(item)
						})
					} else {
						this.dataError = true
					}
					this.searchForm.keywords = ''
					if (!this.scroll) {
						this.log.list = data
					} else {
						this.log.list = this.log.list.concat(data)
					}
					this.busy = false
				},
				() => {
					this.loading = true
				},
			)
		},
		// 搜索日志
		onSearch(options) {
			this.log.tags = []
			this.log.list = []
			this.scroll = false
			this.log.loadPage = 2
			if (this.$route.query.resourceName) {
				console.log('this.$route.query.resourceName', this.$route.query.resourceName)
				this.log.tags.push({
					key: 'resource_name',
					val: this.$route.query.resourceName.split(':')[1],
					text: this.$gettext('Resource Name'),
				})
			} else {
				for (let item in options) {
					if (item === 'keywords' && options[item] !== '') {
						this.log.tags.push({
							key: 'keywords',
							val: options[item],
							text: this.$gettext('Command'),
						})
					}
					if (item === 'resourceType') {
						this.log.tags.push({
							key: 'way',
							val: options[item],
							text: this.$gettext('Resource Type'),
						})
					}
					if (item === 'member') {
						this.log.tags.push({
							key: 'account_name',
							val: options[item],
							text: this.$gettext('Member'),
						})
					}
					if (item === 'ip') {
						this.log.tags.push({
							key: 'ip',
							val: options[item],
							text: this.$gettext('ip'),
						})
					}
					if (item === 'resourceName') {
						this.log.tags.push({
							key: 'resource_name',
							val: options[item],
							text: this.$gettext('Resource Name'),
						})
					}
					if (item === 'unSafeMode') {
						this.log.tags.push({
							key: 'unsafe_mode',
							val: options[item],
							text: this.$gettext('unSafeMode'),
						})
					}
					if (item === 'timeRange') {
						if (options[item][1] === '') {
							this.log.tags.push({
								key: 'timeRange',
								val: `${options[item][0]} - ${this.attrText.now}`,
								text: this.$gettext('End Time'),
							})
						} else {
							this.log.tags.push({
								key: 'timeRange',
								val: `${options[item][0]} - ${options[item][1]}`,
								text: this.$gettext('timeRange'),
							})
						}
					}
				}
			}
			this.getLogList(1)
		},
		// 关闭tags
		onCloseTag(tag) {
			this.log.tags.splice(this.log.tags.indexOf(tag), 1)
			if (this.$route.query.resourceName) {
				this.$router.push({ name: 'logs' })
			}
			this.scroll = false
			this.getLogList(1)
		},
		// 关闭侧滑回调
		onClosePanel() {
			this.currentRightPanel = null
			this.rightPanelData = null
		},
		videoReply() {
			const url = baseUrl.apiUrl + '/video/rdp_replay'
			window.open(url, '_blank')
		},
		// 显示日志高级搜索
		onShowLogSearch() {
			const time = !this.currentRightPanel || this.currentRightPanel.name === 'LogSearch' ? 0 : 300
			this.currentRightPanel = LogSearch
			this.$nextTick(() => {
				setTimeout(() => {
					this.rightPanelData = []
				}, time)
			})
		},
		// 显示生成日志报告
		onShowLogReport() {
			const time = !this.currentRightPanel || this.currentRightPanel.name === 'LogReport' ? 0 : 300
			this.currentRightPanel = LogReport
			this.$nextTick(() => {
				setTimeout(() => {
					this.rightPanelData = []
				}, time)
			})
		},
		tableRowClassName(row, index) {
			if (index % 2 === 0) {
				return 'info-row'
			}
			return ''
		},

		// 查看日志
		viewLog(row, isDialog) {
			const params = {
				code: row.code,
				way: row.way,
				connection_id: row.connection_id,
				check: 1,
			}
			if (isDialog) {
				params.check = 0
				this.$notify({
					type: 'success',
					message: this.$gettext('正在解冻中!'),
				})
			}
			clearTimeout(this.pollingTimer)
			// 复用polling逻辑，但新增查看日志的回调标识
			this.polling({ ...params, action: 'view' }, row)
		},

		// 加载日志内容（核心查看逻辑）
		loadLogContent(row) {
			this.viewLogLoading = true
			// 调用日志内容接口（需替换为实际接口地址）
			this.$store
				.dispatch(STORE_CONST.LOG.VIEW_LOG, {
					params: {
						code: row.code,
						way: row.way,
						connection_id: row.connection_id,
						show: 1,
					},
				})
				.then((res) => {
					console.log(res, 'res')

					this.viewLogLoading = false
					// this.logContent = res || '暂无日志内容'
					// 过滤ANSI转义序列后再赋值
					const cleanContent = Utility.Utils.filterAnsiEscapeCodes(res || '')
					this.logContent = cleanContent || '暂无日志内容'
					this.viewLogShow = true // 打开查看弹窗
				})
				.catch(() => {
					this.viewLogLoading = false
					this.$message.error('日志内容加载失败')
				})
		},

		// 关闭查看日志弹窗
		closeViewLogDialog() {
			this.viewLogShow = false
			this.logContent = ''
			this.viewLogRow = ''
		},

		downLog(row, isDialog) {
			const params = {
				code: row.code,
				way: row.way,
				connection_id: row.connection_id,
				check: 1,
			}
			if (isDialog) {
				params.check = 0
				this.$notify({
					type: 'success',
					message: this.$gettext('正在解冻中!'),
				})
			}
			clearTimeout(this.pollingTimer)
			this.polling(params, row)
		},

		handleFreezeConfirm() {
			// 判断是下载还是查看操作
			if (this.viewLogRow) {
				this.viewLog(this.viewLogRow, true)
				this.viewLogRow = ''
			} else {
				this.downLog(this.freezeShowRow, true)
			}
		},

		/* downLogFile(row) {
			this.$store.dispatch(STORE_CONST.LOG.UNFREEZE, { params: params }).then((res) => {
				if (Object.keys(res).length) return
				window.open(row.downloadLink, '__blank')
			})
		}, */

		polling(params, row) {
			this.$store.dispatch(STORE_CONST.LOG.UNFREEZE, { params: params }).then((res) => {
				console.log(res, 'res轮询')
				if (Object.keys(res).length) {
					if (res.code == 'OSSFileArchived') {
						this.pollingCode = res.code
						// 判断是下载还是查看操作，设置不同的行数据
						if (params.action === 'view') {
							this.viewLogRow = row
						} else {
							this.freezeShowRow = row
						}
						// 打开解冻确认弹窗
						this.freezeShow = true
					} else if (res.code == 'OSSFileRestoring') {
						this.pollingCode = res.code
						params.check = 1
						this.freezeShow = true
						this.pollingLoading = true
						this.pollingTimer = setTimeout(() => {
							this.polling(params, row)
						}, 3000)
					}
				} else {
					this.pollingCode = 'OSSFileAvailable'
					this.pollingLoading = false
					this.freezeShow = false
					// 根据操作类型执行不同逻辑
					if (params.action === 'view') {
						this.loadLogContent(row) // 查看日志
					} else {
						window.open(row.downloadLink, '__blank') // 下载日志
					}
				}
			})
		},

		closeDialog() {
			this.freezeShow = false
			this.pollingCode = ''
			this.viewLogRow = ''
			clearTimeout(this.pollingTimer)
		},
	},
	destroyed() {
		clearTimeout(this.pollingTimer)
	},
	watch: {
		languageCurrent: function (newVal, oldVal) {
			this.onSearch({})
		},
	},
	components: {
		LogSearch,
		LogReport,
	},
}
</script>

<style lang="scss" rel="stylesheet/scss">
@import '../../assets/css/variable';

.log {
	.no-data {
		text-align: center;
		line-height: 200px;
	}
	.log-search {
		padding: 15px 20px;
		.search {
			position: relative;
			.search-input {
				width: 300px;
				height: 100%;
			}
			/*  .search-btn {
          border-color: #bfcbd9;
          color: black;
          &:hover {
            border-color: #f60;
            color: #f60;
          }
        } */
			.search-right {
				position: absolute;
				top: 0px;
				right: 20px;
				a {
					margin-left: 10px;
					color: $mainColor;
				}
				a[disabled] {
					color: $textColor;
				}
			}
		}
	}
	.table-wrapper {
		padding: 0 20px;
		.play {
			color: $mainColor;
			cursor: pointer;
		}
		.searchTag {
			margin-bottom: 10px;
			.el-tag {
				padding: 0 10px;
				height: 30px;
				line-height: 30px;
				border: 1px solid $border-color;
				background-color: #fff;
				color: #333;
				&:hover {
					border-color: $mainColor;
				}
			}
		}
		.el-table__body-wrapper {
			overflow-y: auto;
		}
		.el-collapse-item__header {
			cursor: default;
		}
		a {
			color: $mainColor;
			cursor: pointer;
		}
		.accont-name {
			margin-bottom: 3px;
			height: 25px;
			span {
				margin-right: 10px;
				float: left;
			}
			.text-space {
				max-width: 36%;
				display: inline-block;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}
			.warn {
				margin: 3px 7px 0 0;
				float: left;
				color: red;
			}
			.project-name {
				padding: 1px 3px;
				margin-left: 5px;
				max-width: 80px;
				background-color: #fea542;
				color: #fff;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}
		}
		.avatar-wrapper {
			display: flex;
			align-items: center;
			min-width: 50px;
			.avatar {
				width: 60px;
				height: 60px;
				border-radius: 50%;
				margin-right: 10px;
			}
		}
		.el-height {
			height: 60px;
		}
		.el-collapse-item__header {
			height: 80px;
			line-height: 1;
			padding: 20px 10px;
		}
		.el-collapse-item__wrap {
			background-color: $bgColor;
		}
		.el-collapse-item__header__arrow {
			line-height: 40px;
			&:hover {
				cursor: pointer;
			}
		}

		.el-table__row {
			td {
				padding: 10px 0;
			}
		}
	}
	.no-more {
		line-height: 80px;
		text-align: center;
	}
	.text-space {
		margin-left: 10px;
	}
	.play-url {
		margin-right: 10px;
	}
	.view-url {
		color: $mainColor;
		cursor: pointer;
		margin-right: 10px;
	}
	.down-url {
		color: $mainColor;
		cursor: pointer;
	}
	.el-button--default {
		padding: 0 20px;
		height: 32px;
		min-width: 80px;
	}
}

// 日志查看内容样式
.log-view-content {
	max-height: 70vh;
	overflow-y: auto;
	padding: 10px;

	pre {
		white-space: pre-wrap; // 保留空格和换行
		// word-wrap: break-word; // 禁用自动换行
		overflow-x: auto; // 横向滚动
		font-family: 'Consolas', 'Monaco', monospace; // 等宽字体，适配日志
		font-size: 14px;
		line-height: 1.5;
		color: #333;
		background-color: #f8f8f8;
		padding: 15px;
		border-radius: 4px;
		margin: 0;
	}
}
</style>



// WEBPACK FOOTER //
// logs.vue?61b5a4e6